module.exports = __webpack_public_path__ + "static/media/jaime.1ff142ca.png";